import { useMemo } from "react";
import { movies } from "@/mocks/movies";
import { newsList } from "@/mocks/news";
import MovieCard from "@/components/feature/MovieCard";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import NewsBrief from "@/pages/home/components/NewsBrief";
import AboutBrief from "@/pages/home/components/AboutBrief";
import { usePageMeta } from "@/hooks/usePageMeta";

const featuredIds = [
  "tv-long-night-river",
  "movie-drifter-dawn",
  "anime-star-track",
  "tv-silent-testimony",
  "movie-hunter-action",
];

export default function Home() {
  usePageMeta(
    "蜜月TV - 最新影视剧资讯与精彩电影推荐",
    "蜜月TV为您提供丰富的影视剧资讯和精彩电影推荐，涵盖电视剧、电影多样内容，满足观影爱好者的需求。探索热门影片，了解影视动态，尽在蜜月TV。",
  );

  const featured = useMemo(
    () => featuredIds.map((id) => movies.find((m) => m.id === id)).filter(Boolean),
    [],
  );
  const hotMovies = useMemo(
    () => [...movies].sort((a, b) => b.rating - a.rating).slice(0, 12),
    [],
  );

  return (
    <div className="w-full">
      <div className="w-full px-0 lg:px-8 pt-0 lg:pt-6">
        <HeroCarousel items={featured as typeof movies} />
      </div>

      <div className="w-full px-4 md:px-8 py-10 md:py-12 space-y-12 md:space-y-16">
        <CategoryEntries />

        <section className="w-full">
          <div className="flex items-end justify-between mb-5">
            <div>
              <h2 className="text-xl md:text-2xl font-black text-foreground-950">热门影视推荐</h2>
              <p className="text-sm text-foreground-500 mt-1">高口碑与高热度作品精选</p>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
            {hotMovies.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        </section>

        <NewsBrief items={newsList} />

        <AboutBrief />
      </div>
    </div>
  );
}